/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationNotificationsScheduledNotificationItemPriority } from './FxIdApplicationNotificationsScheduledNotificationItemPriority';
import {
    FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSON,
    FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSONTyped,
    FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSON,
    FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSONTyped,
} from './FxIdApplicationNotificationsScheduledNotificationItemPriority';

/**
 * Элемент запланированного уведомления от игры
 * @export
 * @interface FxIdApplicationNotificationsScheduledNotificationItem
 */
export interface FxIdApplicationNotificationsScheduledNotificationItem {
    /**
     * Заголовок уведомления
     * @type {string}
     * @memberof FxIdApplicationNotificationsScheduledNotificationItem
     */
    Title: string;
    /**
     * Текст уведомления
     * @type {string}
     * @memberof FxIdApplicationNotificationsScheduledNotificationItem
     */
    Body: string;
    /**
     * Время отправки (UTC)
     * @type {Date}
     * @memberof FxIdApplicationNotificationsScheduledNotificationItem
     */
    ScheduledAt: Date;
    /**
     * Подзаголовок (опционально)
     * @type {string}
     * @memberof FxIdApplicationNotificationsScheduledNotificationItem
     */
    Subtitle?: string | null;
    /**
     * 
     * @type {FxIdApplicationNotificationsScheduledNotificationItemPriority}
     * @memberof FxIdApplicationNotificationsScheduledNotificationItem
     */
    Priority?: FxIdApplicationNotificationsScheduledNotificationItemPriority | null;
}

/**
 * Check if a given object implements the FxIdApplicationNotificationsScheduledNotificationItem interface.
 */
export function instanceOfFxIdApplicationNotificationsScheduledNotificationItem(value: object): value is FxIdApplicationNotificationsScheduledNotificationItem {
    if (!('Title' in value) || value['Title'] === undefined) return false;
    if (!('Body' in value) || value['Body'] === undefined) return false;
    if (!('ScheduledAt' in value) || value['ScheduledAt'] === undefined) return false;
    return true;
}

export function FxIdApplicationNotificationsScheduledNotificationItemFromJSON(json: any): FxIdApplicationNotificationsScheduledNotificationItem {
    return FxIdApplicationNotificationsScheduledNotificationItemFromJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduledNotificationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationNotificationsScheduledNotificationItem {
    if (json == null) {
        return json;
    }
    return {
        
        'Title': json['Title'],
        'Body': json['Body'],
        'ScheduledAt': (new Date(json['ScheduledAt'])),
        'Subtitle': json['Subtitle'] == null ? undefined : json['Subtitle'],
        'Priority': json['Priority'] == null ? undefined : FxIdApplicationNotificationsScheduledNotificationItemPriorityFromJSON(json['Priority']),
    };
}

export function FxIdApplicationNotificationsScheduledNotificationItemToJSON(json: any): FxIdApplicationNotificationsScheduledNotificationItem {
    return FxIdApplicationNotificationsScheduledNotificationItemToJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduledNotificationItemToJSONTyped(value?: FxIdApplicationNotificationsScheduledNotificationItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Title': value['Title'],
        'Body': value['Body'],
        'ScheduledAt': ((value['ScheduledAt']).toISOString()),
        'Subtitle': value['Subtitle'],
        'Priority': FxIdApplicationNotificationsScheduledNotificationItemPriorityToJSON(value['Priority']),
    };
}

